import injectSheet from "react-jss";
import styles from "../apiaccesss/apiaccess_styles";
import {
    displaySuccessMessage,
    displayModal, Loader
} from "@insticator/insticator-ui";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { ReactComponent as BarChart } from "assets/icons/bar.svg";
import {CopyField} from "@insticator/insticator-ui/dist/material";
import {createReportApiKey, fetchReportApiKey} from "../../../../../state/thunks/settings";
import {fetchAccountSettings, updateApiAccess} from "../../../../../state/thunks/account";
import Information from "../../../../../material/information/information";
import {checkDaysOfDifference, convertTimestampsToDate, dateToArray} from "../../../../../utils/date";
import SectionWithCTAs from "../../../../../material/expandablesection/sectionwithcta/sectionwithcta";
import store from "../../../../../state/store/store";
import ApproveModal from "./approvemodal";
import ConfigV2Controller from "../../../../../material/expandablesection/v2/configv2controller/configv2controller";
import ExpandableSection from "../../../../../material/expandablesection/expandablesection";
import {ConfigToggle} from "../../../../../material/expandablesection/v2";

const ApiAccessPage = injectSheet(styles)((props) => {
    const dispatch = useDispatch();
    const accountUUID = useSelector((state) => state.session.accountUUID);
    const accountSettings = useSelector((state) => state.account.accountSettings);
    const reportApiKeyObject = useSelector((state) => state.settings.reportApiKeyObject);
    const reportApiKeyRequestStatus = useSelector((state) => state.settings.reportApiKeyRequestStatus);
    const [isOpened, setIsOpened] = useState(false);
    const [enableApiAccess, setEnableApiAccess] = useState(accountSettings.enableApiAccess);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isExpired, setIsExpired] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const parseAccountSettings = () => {
        return {
            accountUUID: accountUUID,
            settings: {...accountSettings, enableApiAccess : !enableApiAccess},
        }
    }

    const handleToggle = () => {
        setIsOpened(!isOpened);
        setEnableApiAccess(!enableApiAccess);
        dispatch(updateApiAccess(parseAccountSettings()));
    }

    const handleCopy = (fieldVal, e) => {
        navigator.clipboard.writeText(fieldVal)
    }

    const getKeyExpiredStatus = () => {
        if(Object.keys(reportApiKeyObject).length === 0)  return false;
        const now = new Date();
        return convertTimestampsToDate(reportApiKeyObject.expirationDate) < now;
    }

    const cancel = () => dispatch(displayModal(false))

    const openConfirmationModal = () => {
        if(!getKeyExpiredStatus()) {
            return dispatch(displayModal(true,
                <ApproveModal handleCancel={cancel} handleApprove={() => {cancel(); createApiKey().then()}} />
            ));
        } else {
            createApiKey().then();
        }

    };


    const checkUsageTime = () => {
        if(Object.keys(reportApiKeyObject).length === 0)  return false;
        const startDate = reportApiKeyObject.createdAt;
        const endDate = reportApiKeyObject.expirationDate;
        // if api key has been generated but not being used for 30 days or more
        return checkDaysOfDifference(startDate, endDate, 90) && !checkDaysOfDifference(startDate, dateToArray(new Date()), 30);
    }

   const createApiKey =  useCallback(async() => {
       setIsProcessing(true);
       setIsLoading(true);
       const response = await dispatch(createReportApiKey(accountUUID));
       if(response.payload) {
           store.dispatch(displaySuccessMessage('Generated a new API key'))
           setTimeout(() => {
               setIsProcessing(false);
               setIsLoading(false);
           },1000)

       }
   })

   const getApiKey = async() => {
           const response = await dispatch(fetchReportApiKey(accountUUID));
           if(response.error) {
               await dispatch(createReportApiKey(accountUUID));
           }
           setIsLoading(false);
           setIsOpened(true);
   }

    useEffect(() => {
        dispatch(fetchAccountSettings(accountUUID));
    }, [])

    useEffect(() => {
        if (enableApiAccess) {
            getApiKey();
        } else {
            setIsOpened(false);
        }
    }, [enableApiAccess])

    const controller = (
        <div className={'apiaccessconfig'}>
        <ConfigV2Controller
            isOpened={true}
            isProcessing={isProcessing}
            saveTitle={'Save Changes'}
            icon={<BarChart />}
            title='Report Builder Api'
        /><ConfigToggle
                checked={isOpened}
                onChange={handleToggle}
                title={'Enable API Access'}
        ></ConfigToggle>

       </div>
    );

    return (
        <ExpandableSection
            className={`expandablesectionv2 apiaccesssection ${props.classes.apiaccesssection}`}
            controller={controller}
            isOpened={isOpened}
            handleCancel = {() => {window.open('https://documentation.insticator.com/docs/report-api')}}
            handleSave={openConfirmationModal}
            isProcessing={isProcessing}
            hideFooter={true}
            children={<SectionWithCTAs
                className={props.classes.expandableSection}
                isActionProcessing={isProcessing}
                actionButtonText={`Generate New API key`}
                processingText={'Generating...'}
                performAction = {openConfirmationModal}
                handleClick = {() => {window.open('https://documentation.insticator.com/docs/report-api')}}
                normalButtonText = {'Documentation'}
                isActionButtonDisabled = {!getKeyExpiredStatus()}
                ctaIcon = {'book'}
            >
                {isLoading && <Loader></Loader>}
                {!isLoading && <>
                    <label className={props.classes.fieldLabel}>Account Id</label>
                    <CopyField
                        className={props.classes.accountId}
                        name={'accountId'}
                        defaultValue={accountUUID}
                        handleCopy={(fieldVal, e) => handleCopy(fieldVal, e)}
                        height={'inline'}
                        readOnly={true}
                        margin={'16px'}
                        ctaVariant={'primary'}
                        ctaPosition={'inline'}
                        fieldType={'text'}
                        copyItemName={''}/>
                    <label className={props.classes.fieldLabel}>API Key</label>
                    <CopyField
                        className={props.classes.copyInput}
                        name={'apiKey'}
                        defaultValue={reportApiKeyObject.apiKey}
                        handleCopy={(fieldVal, e) => handleCopy(fieldVal, e)}
                        height={'inline'}
                        readOnly={true}
                        margin={'16px'}
                        ctaVariant={'primary'}
                        ctaPosition={'inline'}
                        fieldType={'text'}
                        copyItemName={''}
                    />
                </>}


                {checkUsageTime() &&
                    <Information message={'This API key has not been used for more than 30 days.'}></Information>}
                {getKeyExpiredStatus() &&
                    <Information message={'The API key has expired . Please generate a new one.'}></Information>}

            </SectionWithCTAs>}
        >
        </ExpandableSection>


    )
});
export default ApiAccessPage;

